import createReducer from '../utils/createReducer';
import actions from '../actions/masterBrand';

const initialState = {};

const actionHandlers = {
    [actions.GET_MASTER_BRAND_DATA_SUCCESS](state, {payload}) {
        const companyCountryCode = payload.companyCountryCode;
        const countryList = payload.countryList;
        return {
            ...state,
            user: payload.user,
            companyCountryCode,
            companyCountry: countryList instanceof Array ? countryList.find((e) => e.countryCode === companyCountryCode) : null
        };
    },

    [actions.GET_MASTER_BRAND_DATA_ERROR](state, {payload}) {
        return {
            ...state,
            errorKey: payload.errorKey
        };
    },

    [actions.GET_REDIRECT_BRAND_DETAILS](state, {payload}) {
        const {currency, supportedCurrencies, siteName} = payload;
        let supportedCurrencyInfo;

        if (currency) {
            supportedCurrencyInfo = supportedCurrencies.find((currencyObject) => currencyObject.currency.includes(currency));
        } else {
            supportedCurrencyInfo = supportedCurrencies[0];
        }

        return {
            ...state,
            brandName: supportedCurrencyInfo.brandName,
            hostName: supportedCurrencyInfo.hostName,
            redirectFlag: !!(siteName !== supportedCurrencyInfo.siteName),
            redirectLink: supportedCurrencyInfo.redirectLink,
            userCurrency: currency || supportedCurrencyInfo.currency[0]
        };
    }
};

export default createReducer(actionHandlers, initialState);
